/* eslint-disable no-irregular-whitespace */

/**
 * @Description Admin module saga/watcher file.
 * @FileName moduleWatcher.js
 * @Author Arnab Sutar - sutaarn
 * @CreatedOn 22 January, 2021 08:51:22
 * @IssueID - 308
 */
import { takeEvery, put, call, all } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import { notificationEventsActionType, notificationUsersActionType } from '../actions/actionTypes';

import { exportErrorMsg, Logger, processError, renderFileName } from '../../../../common/util';
import invokeApi from '../../../../common/apiManagement/invokeApi';
import { getAction } from '../../../../../stateManagement/reduxUtil';
import {
  processingStarted, processingCompleted,
} from '../../../../common/redux/actions/commonActions';
import moduleAPI from '../../config/apiConfig';
import { globalConstants } from '../../../../common/moduleConstants';

/**
   * Get Access Options List
   * @param {any} action
   */
export function* getEventsList(action) {
  Logger.verbose(`Action Detail For Get Gen Edit Type List : ${JSON.stringify(action)}`);
  yield all([
    put(processingStarted()),
    put(getAction(notificationEventsActionType.RESET_SERVER_VALUE, null)),
    put(getAction(notificationEventsActionType.LOG_NOTIF_EVENTS_LIST_REQUEST, action.data)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.ADMINISTRATION_NOTIF_EVENTS_LIST, action.data);
    yield all([
      put(getAction(notificationEventsActionType.GET_NOTIF_EVENTS_LIST_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      // put(getAction(systemOptionsActionType.GET_SYS_OPT_DETAIL_ERROR, processError(err))),
      put(getAction(notificationEventsActionType.GET_NOTIF_EVENTS_LIST_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
}
/**
   * Get Access Options by id
   * @param {object} action
   */
export function* geEventbyID(action) {
  Logger.verbose(`Action Detail For Get ADMINISTRATION_NOTIF_EVENTS_BY_ID by id : ${JSON.stringify(action)}`);
  yield all([
    put(processingStarted()),
    put(getAction(notificationEventsActionType.LOG_NOTIF_EVENTS_BY_ID_REQUEST, action.data)),
    put(getAction(notificationEventsActionType.GET_NOTIF_EVENTS_LIST_ERROR, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.ADMINISTRATION_NOTIF_EVENTS_BY_ID, action.data);
    yield all([
      put(getAction(notificationEventsActionType.GET_NOTIF_EVENTS_BY_ID_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(notificationEventsActionType.GET_NOTIF_EVENTS_LIST_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
}
// notificationEventsActionType.GET_NOTIF_EVENTS_LIST_ERROR, processError(err)
/**
   * This generator function will invoke the api
   * @param {object} action - action which will insert for Access Options
   */
export function* insertEvents(action) {
  Logger.verbose(`Action Detail For Get Sys Param : ${JSON.stringify(action)}`);
  yield all([put(processingStarted())]);
  let resetUpsertValue = null;
  try {
    const responseData = yield call(
      invokeApi,
      moduleAPI.ADMINISTRATION_NOTIF_EVENTS_INSERT,
      action.data.formatObject,
    );
    resetUpsertValue = {
      upsertRequest: null,
      upsertRequestError: null,
      upsertRequestedOn: null,
      upsertRequestProcessedOn: new Date(),
      upsertData: responseData,
    };
    yield all([
      put(getAction(notificationEventsActionType.RESET_UPSERT_VALUE, resetUpsertValue)),
      // put(getAction(notificationEventsActionType.GET_ACCESSOPTS_LIST_REQUEST, action.data.reqObject)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    resetUpsertValue = {
      upsertRequest: null,
      upsertRequestError: processError(err),
      upsertRequestedOn: null,
      upsertRequestProcessedOn: null,
      upsertData: null,
    };
    yield all([
      put(getAction(notificationEventsActionType.RESET_UPSERT_VALUE, resetUpsertValue)),
      put(processingCompleted()),
    ]);
  }
}
// update Access Options
export function* updateEvent(action) {
  yield all([put(processingStarted())]);
  let resetUpsertValue = null;
  try {
    const responseData = yield call(
      invokeApi,
      moduleAPI.ADMINISTRATION_NOTIF_EVENTS_UPDATE,
      action.data.formatObject,
    );
    resetUpsertValue = {
      upsertRequest: null,
      upsertRequestError: null,
      upsertRequestedOn: null,
      upsertRequestProcessedOn: new Date(),
      upsertData: responseData,
    };
    yield all([put(getAction(notificationEventsActionType.RESET_UPSERT_VALUE, resetUpsertValue)),
      put(getAction(notificationEventsActionType.GET_NOTIF_EVENTS_LIST_REQUEST, action.data.reqObject)),
      put(processingCompleted())]);
  } catch (err) {
    resetUpsertValue = {
      upsertRequest: null,
      upsertRequestError: processError(err),
      upsertRequestedOn: null,
      upsertRequestProcessedOn: null,
    };
    yield all([
      put(getAction(notificationEventsActionType.RESET_UPSERT_VALUE, resetUpsertValue)),
      put(processingCompleted()),
    ]);
  }
}

/**
  * This generator function will invoke the api
  * @param {object} action - action which will request for SP Export Listing
  */
export function* getEventExportList(action) {
  let resetServerValue = null;
  yield all([
    put(processingStarted()),
    put(getAction(notificationEventsActionType.GET_NOTIF_EVENTS_LIST_ERROR, resetServerValue)),
  ]);
  try {
    const responseData = yield call(
      invokeApi,
      moduleAPI.ADMINISTRATION_NOTIFY_EVENT_EXPORT_LIST,
      action.data,
    );
    const filename = renderFileName(responseData);
    const urlData = window.URL.createObjectURL(new Blob([responseData.data]));
    FileSaver(urlData, filename);
    yield put(processingCompleted());
  } catch (err) {
    if (err.response.status === globalConstants.errorCode402 || err.response.status === globalConstants.errorCode403) {
      const exportMaxLimitErrorObj = exportErrorMsg(err.response.status);
      resetServerValue = exportMaxLimitErrorObj;
    } else {
      resetServerValue = processError(err);
    }
    yield all([
      put(getAction(notificationEventsActionType.GET_NOTIF_EVENTS_LIST_ERROR, resetServerValue)),
      put(processingCompleted()),
    ]);
  }
}
/**
   * This generator function will invoke the api
   * @param {object} action - action which will delete existing Access Options
   */
export function* deleteEvent(action) {
  yield all([put(processingStarted())]);
  let resetDeleteValue = null;
  try {
    const responseData = yield call(
      invokeApi,
      moduleAPI.ADMINISTRATION_NOTIF_EVENTS_DELETE,
      action.data.formatObject,
    );
    resetDeleteValue = {
      deleteRequest: null,
      deleteRequestError: null,
      deleteRequestedOn: null,
      deleteRequestProcessedOn: new Date(),
      deleteData: responseData,
    };
    yield all([put(getAction(notificationEventsActionType.RESET_DELETE_VALUE, resetDeleteValue)),
      put(getAction(notificationEventsActionType.GET_NOTIF_EVENTS_LIST_REQUEST, action.data.reqObject)),
      put(processingCompleted())]);
  } catch (err) {
    resetDeleteValue = {
      deleteRequest: null,
      deleteRequestError: processError(err),
      deleteRequestedOn: new Date(),
      deleteRequestProcessedOn: null,
      deleteData: null,
    };
    yield all([
      put(getAction(notificationEventsActionType.RESET_DELETE_VALUE, resetDeleteValue)),
      put(processingCompleted()),
    ]);
  }
}
export function* getNotificationCon(action) {
  Logger.verbose(`Action Detail For Get Gen Edit Type List : ${JSON.stringify(action)}`);
  yield all([
    put(processingStarted()),
    put(getAction(notificationEventsActionType.RESET_SERVER_VALUE, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.ADMINISTRATION_NOTIFICATION_CONCURRENCY, action.data);
    Logger.verbose(`Action Detail For Get Gen Edit Type List : ${responseData}`);
    yield all([
      put(getAction(notificationEventsActionType.GET_NOTIFICATION_LIST_RESPONSE, 'success')),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      // put(getAction(systemOptionsActionType.GET_SYS_OPT_DETAIL_ERROR, processError(err))),
      put(getAction(notificationEventsActionType.GET_NOTIFICATION_ADDCONC_ERROR, processError(err))),
      put(processingCompleted()),
      put(getAction(notificationEventsActionType.GET_NOTIFICATION_LIST_RESPONSE, 'fail')),
    ]);
  }
}

/**
   * Get Access Options List
   * @param {any} action
   */
export function* getUsersList(action) {
  Logger.verbose(`Action Detail For Get Gen Edit Type List : ${JSON.stringify(action)}`);
  yield all([
    put(processingStarted()),
    put(getAction(notificationUsersActionType.RESET_SERVER_VALUE, null)),
    put(getAction(notificationUsersActionType.LOG_NOTIF_USERS_LIST_REQUEST, action.data)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.ADMINISTRATION_NOTIF_USERS_LIST, action.data);
    yield all([
      put(getAction(notificationUsersActionType.GET_NOTIF_USERS_LIST_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      // put(getAction(systemOptionsActionType.GET_SYS_OPT_DETAIL_ERROR, processError(err))),
      put(getAction(notificationUsersActionType.GET_NOTIF_USERS_LIST_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
}

/**
   * Get Access Options by id
   * @param {object} action
   */
export function* geUserbyID(action) {
  Logger.verbose(`Action Detail For Get ADMINISTRATION_NOTIF_USER_BY_ID by id : ${JSON.stringify(action)}`);
  yield all([
    put(processingStarted()),
    put(getAction(notificationUsersActionType.LOG_NOTIF_USERS_BY_ID_REQUEST, action.data)),
    put(getAction(notificationUsersActionType.GET_NOTIF_USERS_LIST_ERROR, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.ADMINISTRATION_NOTIF_USERS_BY_ID, action.data);
    yield all([
      put(getAction(notificationUsersActionType.GET_NOTIF_USERS_BY_ID_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(notificationUsersActionType.GET_NOTIF_USERS_LIST_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
}

/**
   * This generator function will invoke the api
   * @param {object} action - action which will delete existing Access Options
   */
export function* deleteUser(action) {
  yield all([put(processingStarted())]);
  let resetDeleteValue = null;
  try {
    const responseData = yield call(
      invokeApi,
      moduleAPI.ADMINISTRATION_NOTIF_USERS_DELETE,
      action.data.formatObject,
    );
    resetDeleteValue = {
      deleteRequest: null,
      deleteRequestError: null,
      deleteRequestedOn: null,
      deleteRequestProcessedOn: new Date(),
      deleteData: responseData,
    };
    yield all([put(getAction(notificationUsersActionType.RESET_DELETE_VALUE, resetDeleteValue)),
      put(getAction(notificationUsersActionType.GET_NOTIF_USERS_LIST_REQUEST, action.data.reqObject)),
      put(processingCompleted())]);
  } catch (err) {
    resetDeleteValue = {
      deleteRequest: null,
      deleteRequestError: processError(err),
      deleteRequestedOn: new Date(),
      deleteRequestProcessedOn: null,
      deleteData: null,
    };
    yield all([
      put(getAction(notificationUsersActionType.RESET_DELETE_VALUE, resetDeleteValue)),
      put(processingCompleted()),
    ]);
  }
}

// update Notify Users
export function* updateUsers(action) {
  yield all([put(processingStarted())]);
  let resetUpsertValue = null;
  try {
    const responseData = yield call(
      invokeApi,
      moduleAPI.ADMINISTRATION_NOTIF_USERS_UPDATE,
      action.data.formatObject,
    );
    resetUpsertValue = {
      upsertRequest: null,
      upsertRequestError: null,
      upsertRequestedOn: null,
      upsertRequestProcessedOn: new Date(),
      upsertData: responseData,
    };
    yield all([put(getAction(notificationUsersActionType.RESET_UPSERT_VALUE, resetUpsertValue)),
      put(getAction(notificationUsersActionType.GET_NOTIF_USERS_LIST_REQUEST, action.data.reqObject)),
      put(processingCompleted())]);
  } catch (err) {
    resetUpsertValue = {
      upsertRequest: null,
      upsertRequestError: processError(err),
      upsertRequestedOn: null,
      upsertRequestProcessedOn: null,
    };
    yield all([
      put(getAction(notificationUsersActionType.RESET_UPSERT_VALUE, resetUpsertValue)),
      put(processingCompleted()),
    ]);
  }
}

/**
  * This generator function will invoke the api
  * @param {object} action - action which will request for SP Export Listing
  */
export function* getUsersExportList(action) {
  let resetServerValue = null;
  yield all([
    put(processingStarted()),
    put(getAction(notificationUsersActionType.GET_NOTIF_USERS_LIST_ERROR, resetServerValue)),
  ]);
  try {
    const responseData = yield call(
      invokeApi,
      moduleAPI.ADMINISTRATION_NOTIFY_USERS_EXPORT_LIST,
      action.data,
    );
    const filename = renderFileName(responseData);
    const urlData = window.URL.createObjectURL(new Blob([responseData.data]));
    FileSaver(urlData, filename);
    yield put(processingCompleted());
  } catch (err) {
    if (err.response.status === globalConstants.errorCode402 || err.response.status === globalConstants.errorCode403) {
      const exportMaxLimitErrorObj = exportErrorMsg(err.response.status);
      resetServerValue = exportMaxLimitErrorObj;
    } else {
      resetServerValue = processError(err);
    }
    yield all([
      put(getAction(notificationUsersActionType.GET_NOTIF_USERS_LIST_ERROR, resetServerValue)),
      put(processingCompleted()),
    ]);
  }
}

function* moduleWatcher() {
  // Notification Events
  yield takeEvery(notificationEventsActionType.DELETE_NOTIF_EVENTS_REQUEST, deleteEvent);
  yield takeEvery(notificationEventsActionType.INSERT_NOTIF_EVENTS_REQUEST, insertEvents);
  yield takeEvery(notificationEventsActionType.GET_NOTIF_EVENTS_LIST_REQUEST, getEventsList);
  yield takeEvery(notificationEventsActionType.GET_NOTIF_EVENTS_BY_ID_REQUEST, geEventbyID);
  yield takeEvery(notificationEventsActionType.UPDATE_NOTIF_EVENTS_REQUEST, updateEvent);
  yield takeEvery(notificationEventsActionType.GET_NOTIF_EVENTS_EXPORT_REQUEST, getEventExportList);
  yield takeEvery(notificationEventsActionType.GET_NOTIFICATION_ADDCONC, getNotificationCon);

  // Notification Users
  yield takeEvery(notificationUsersActionType.GET_NOTIF_USERS_LIST_REQUEST, getUsersList);
  yield takeEvery(notificationUsersActionType.GET_NOTIF_USERS_BY_ID_REQUEST, geUserbyID);
  yield takeEvery(notificationUsersActionType.DELETE_NOTIF_USERS_REQUEST, deleteUser);
  yield takeEvery(notificationUsersActionType.UPDATE_NOTIF_USERS_REQUEST, updateUsers);
  yield takeEvery(notificationUsersActionType.GET_NOTIF_USERS_EXPORT_REQUEST, getUsersExportList);
}
export default moduleWatcher;
